<template>
  <div
    id="select-product"
    class="row mt-3"
  >
    <div class="col-md-12">
      <div class="col-heading">
        <h3 class="mb-4">
          {{ productName }}
        </h3>
      </div>
      <div class="form-group card-container">
        <div
          v-if="pending"
          class="product-list"
        >
          <div
            v-for="(n, index) in 3"
            :key="index"
            class="product-list__item placeholder-item"
          >
            <div class="product__summary-wrapper">
              <div class="product__summary">
                <div class="product__header">
                  <h2 class="product__title" />
                  <p class="product__price" />
                </div>
                <p class="product-to-terminal" />
                <div class="product-list">
                  <ul>
                    <li />
                    <li />
                    <li />
                    <li />
                  </ul>
                </div>
              </div>
              <div class="product__additional">
                <div class="product__additional-extra">
                  <span class="btn btn-primary mb-2" />
                </div>
                <div class="product__additional-button">
                  <span
                    type="button"
                    class="btn btn-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="noProductsFound"
          class="alert alert-danger mt-5"
          role="alert"
        >
          <h3 class="mb-3">
            No products found!
          </h3>
          <p>Change the criteria above, if possible, and try again.</p>
        </div>
        <div
          v-if="!pending && productName === 'Lounges'"
          class="product-list"
        >
          <ProductOption
            v-for="(option, index) in getProductsWithAvailableQuantity"
            :key="index"
            :disabled="disabled"
            :product-option="option"
          />
        </div>
        <div
          v-if="!pending && productName !== 'Lounges'"
          class="product-list"
        >
          <ProductOption
            v-for="(option, index) in products"
            :key="index"
            :disabled="disabled"
            :product-option="option"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ProductOption from './ProductOption'

export default {
    name: 'SelectProduct',
    components: {
        ProductOption
    },
    props: {
        productName: {
            type: String,
            default: 'error?'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            products: state => state.product.products,
            pending: state => state.product.pending
        }),
        ...mapGetters({
            getProductsWithAvailableQuantity:
                'product/getProductsWithAvailableQuantity'
        }),
        selectedProductId: {
            get () {
                return this.$store.state.product.selectedProductId
            },
            set (value) {
                this.$store.commit('product/setSelectedProductId', value)
            }
        },
        noProductsFound () {
            return this.pending === false && this.products.length === 0
        }
    }
}
</script>
